// Icon names should always be in kebab-case
// Icons should always be lazy loaded, meaning a function that returns a Promise with the SVG markup.
// Generally speaking we only use outlined (and not filled) icons.
// In case a filled icon is used, omit the `-filled` suffix from the icon name.
// We don't combine filled and outlined icons, so we don't need developers to specify this.
// The design team will decide when a filled icon is used instead of an outlined one.
const ICONS = {
    ad: [async () => await import('./ad.js'), []],
    adjustments: [async () => await import('./adjustments.js'), []],
    'alert-circle': [async () => await import('./alert-circle.js'), []],
    'alert-circle-filled': [async () => await import('./alert-circle2.js'), []],
    'alert-triangle': [async () => await import('./alert-triangle.js'), []],
    'alert-triangle-filled': [async () => await import('./alert-triangle2.js'), []],
    'align-box-bottom-center': [async () => await import('./align-box-bottom-center.js'), []],
    'align-box-center-middle': [async () => await import('./align-box-center-middle.js'), []],
    'align-box-left-middle': [async () => await import('./align-box-left-middle.js'), []],
    'align-box-right-middle': [async () => await import('./align-box-right-middle.js'), []],
    'align-box-top-center': [async () => await import('./align-box-top-center.js'), []],
    'align-justified': [async () => await import('./align-justified.js'), []],
    'antenna-bars-5': [async () => await import('./antenna-bars-5.js'), []],
    apps: [async () => await import('./apps.js'), []],
    'arrow-back-up': [async () => await import('./arrow-back-up.js'), []],
    'arrow-bar-both-horizontal': [async () => await import('./arrow-bar-both.js'), []],
    'arrow-bar-both-vertical': [
        async () => await import('./arrow-bar-both.js'),
        ['rotate-90'],
    ],
    'arrow-bar-down': [async () => await import('./arrow-bar-down.js'), []],
    'arrow-bar-to-left': [async () => await import('./arrow-bar-to-left.js'), []],
    'arrow-bar-to-right': [async () => await import('./arrow-bar-to-right.js'), []],
    'arrow-bar-up': [async () => await import('./arrow-bar-up.js'), []],
    'arrow-down': [async () => await import('./arrow-down.js'), []],
    'arrow-fork': [async () => await import('./arrow-fork.js'), []],
    'arrow-fork-rotated': [async () => await import('./arrow-fork.js'), ['rotate-180']],
    'arrow-left': [async () => await import('./arrow-left.js'), []],
    'arrow-ramp-left': [async () => await import('./arrow-ramp-left.js'), []],
    'arrow-right': [async () => await import('./arrow-right.js'), []],
    'arrow-up': [async () => await import('./arrow-up.js'), []],
    'arrow-up-right': [async () => await import('./arrow-up-right.js'), []],
    'arrows-diagonal-minimize': [
        async () => await import('./arrows-diagonal-minimize-2.js'),
        [],
    ],
    'arrows-diagonal': [async () => await import('./arrows-diagonal.js'), []],
    'arrows-split': [async () => await import('./arrows-split.js'), []],
    'arrow-merge': [async () => await import('./arrow-merge.js'), []],
    'aspect-ratio': [async () => await import('./aspect-ratio.js'), []],
    'badge-cc': [async () => await import('./badge-cc.js'), []],
    ban: [async () => await import('./ban.js'), []],
    'baseline-density-large': [async () => await import('./baseline-density-large.js'), []],
    'baseline-density-medium': [async () => await import('./baseline-density-medium.js'), []],
    'baseline-density-small': [async () => await import('./baseline-density-small.js'), []],
    bolt: [async () => await import('./bolt.js'), []],
    'brand-facebook': [async () => await import('./brand-facebook.js'), []],
    'brand-google': [async () => await import('./brand-google.js'), []],
    'brand-linkedin': [async () => await import('./brand-linkedin.js'), []],
    'brand-pinterest': [async () => await import('./brand-pinterest.js'), []],
    'brand-reddit': [async () => await import('./brand-reddit.js'), []],
    'brand-tumblr': [async () => await import('./brand-tumblr.js'), []],
    'brand-x': [async () => await import('./brand-x.js'), []],
    bulb: [async () => await import('./bulb.js'), []],
    calendar: [async () => await import('./calendar.js'), []],
    cast: [async () => await import('./cast.js'), []],
    chalkboard: [async () => await import('./chalkboard.js'), []],
    'chart-bar': [async () => await import('./chart-bar.js'), []],
    'chart-histogram': [async () => await import('./chart-histogram.js'), []],
    check: [async () => await import('./check.js'), []],
    checks: [async () => await import('./checks.js'), []],
    'chevron-down': [async () => await import('./chevron-down.js'), []],
    'chevron-left': [async () => await import('./chevron-left.js'), []],
    'chevron-right': [async () => await import('./chevron-right.js'), []],
    'chevron-up': [async () => await import('./chevron-up.js'), []],
    click: [async () => await import('./click.js'), []],
    'circle-check': [async () => await import('./circle-check.js'), []],
    'circle-percentage': [async () => await import('./circle-percentage.js'), []],
    'clipboard-list': [async () => await import('./clipboard-list.js'), []],
    'clock-check': [async () => await import('./clock-check.js'), []],
    'clock-play': [async () => await import('./clock-play.js'), []],
    'clipboard-data': [async () => await import('./clipboard-data.js'), []],
    clock: [async () => await import('./clock-hour-4.js'), []],
    code: [async () => await import('./code.js'), []],
    columns: [async () => await import('./columns.js'), []],
    components: [async () => await import('./components.js'), []],
    copy: [async () => await import('./copy.js'), []],
    coin: [async () => await import('./coin.js'), []],
    'credit-card': [async () => await import('./credit-card.js'), []],
    'currency-dollar': [async () => await import('./currency-dollar.js'), []],
    cut: [async () => await import('./cut.js'), []],
    'device-desktop': [async () => await import('./device-desktop.js'), []],
    'device-mobile-rotated': [async () => await import('./device-mobile-rotated.js'), []],
    'device-mobile': [async () => await import('./device-mobile.js'), []],
    'device-mobile-up': [async () => await import('./device-mobile-up.js'), []],
    devices: [async () => await import('./devices.js'), []],
    'devices-pin': [async () => await import('./devices-pin.js'), []],
    dots: [async () => await import('./dots.js'), []],
    download: [async () => await import('./download.js'), []],
    droplet: [async () => await import('./droplet.js'), []],
    'external-link': [async () => await import('./external-link.js'), []],
    'eye-off': [async () => await import('./eye-off.js'), []],
    'eye-x': [async () => await import('./eye-x.js'), []],
    eye: [async () => await import('./eye.js'), []],
    'file-text': [async () => await import('./file-text.js'), []],
    'file-upload': [async () => await import('./file-upload.js'), []],
    filter: [async () => await import('./filter.js'), []],
    flask: [async () => await import('./flask.js'), []],
    forms: [async () => await import('./forms.js'), []],
    github: [async () => await import('./brand-github.js'), []],
    'grip-vertical': [async () => await import('./grip-vertical.js'), []],
    globe: [async () => await import('./globe.js'), []],
    heading: [async () => await import('./heading.js'), []],
    headphones: [async () => await import('./headphones.js'), []],
    'heart-handshake': [async () => await import('./heart-handshake.js'), []],
    'help-filled': [async () => await import('./help-circle.js'), []],
    help: [async () => await import('./help.js'), []],
    home: [async () => await import('./home.js'), []],
    'info-circle': [async () => await import('./info-circle.js'), []],
    'input-search': [async () => await import('./input-search.js'), []],
    key: [async () => await import('./key.js'), []],
    'layout-grid': [async () => await import('./layout-grid.js'), []],
    'layout-sidebar-left-collapse': [
        async () => await import('./layout-sidebar-left-collapse.js'),
        [],
    ],
    'layout-sidebar-left-expand': [
        async () => await import('./layout-sidebar-left-expand.js'),
        [],
    ],
    link: [async () => await import('./link.js'), []],
    'list-check': [async () => await import('./list-check.js'), []],
    list: [async () => await import('./list2.js'), []],
    loader: [async () => await import('./loader-2.js'), []],
    lock: [async () => await import('./lock.js'), []],
    login: [async () => await import('./login.js'), []],
    'magnet-down': [async () => await import('./magnet.js'), ['rotate-180']],
    'magnet-left': [async () => await import('./magnet.js'), ['rotate-270']],
    'magnet-right': [async () => await import('./magnet.js'), ['rotate-90']],
    'magnet-up': [async () => await import('./magnet.js'), []],
    mail: [async () => await import('./mail.js'), []],
    minus: [async () => await import('./minus.js'), []],
    maximize: [async () => await import('./maximize.js'), []],
    moon: [async () => await import('./moon.js'), []],
    'menu-3': [async () => await import('./menu-3.js'), []],
    movie: [async () => await import('./movie.js'), []],
    pencil: [async () => await import('./pencil.js'), []],
    phone: [async () => await import('./phone.js'), []],
    'photo-off': [async () => await import('./photo-off.js'), []],
    photo: [async () => await import('./photo.js'), []],
    'picture-in-picture': [async () => await import('./picture-in-picture.js'), []],
    pig: [async () => await import('./pig.js'), []],
    'pig-off': [async () => await import('./pig-off.js'), []],
    'pig-money': [async () => await import('./pig-money.js'), []],
    'player-pause': [async () => await import('./player-pause.js'), []],
    'player-play': [async () => await import('./player-play.js'), []],
    'player-skip-forward': [async () => await import('./player-skip-forward.js'), []],
    'player-stop': [async () => await import('./player-stop.js'), []],
    playlist: [async () => await import('./playlist.js'), []],
    plus: [async () => await import('./plus.js'), []],
    pointer: [async () => await import('./pointer.js'), []],
    puzzle: [async () => await import('./puzzle.js'), []],
    'question-mark': [async () => await import('./question-mark.js'), []],
    refresh: [async () => await import('./refresh.js'), []],
    'report-analytics': [async () => await import('./report-analytics.js'), []],
    'rewind-backward-10': [async () => await import('./rewind-backward-10.js'), []],
    rotate: [async () => await import('./rotate-2.js'), []],
    rss: [async () => await import('./rss.js'), []],
    search: [async () => await import('./search.js'), []],
    selector: [async () => await import('./selector.js'), []],
    send: [async () => await import('./send.js'), []],
    settings: [async () => await import('./settings.js'), []],
    'share-2': [async () => await import('./share-2.js'), []],
    'share-3': [async () => await import('./share-3.js'), []],
    share: [async () => await import('./share.js'), []],
    shareplay: [async () => await import('./shareplay.js'), []],
    sitemap: [async () => await import('./sitemap.js'), []],
    slash: [async () => await import('./slash.js'), []],
    social: [async () => await import('./social.js'), []],
    'sort-ascending': [async () => await import('./sort-ascending.js'), []],
    'sort-descending': [async () => await import('./sort-descending.js'), []],
    sparkles: [async () => await import('./sparkles.js'), []],
    star: [async () => await import('./star.js'), []],
    sun: [async () => await import('./sun.js'), []],
    tags: [async () => await import('./tags.js'), []],
    'text-recognition': [async () => await import('./text-recognition.js'), []],
    'timeline-event-text': [async () => await import('./timeline-event-text.js'), []],
    tool: [async () => await import('./tool.js'), []],
    trash: [async () => await import('./trash.js'), []],
    target: [async () => await import('./target.js'), []],
    'trending-up': [async () => await import('./trending-up.js'), []],
    unlink: [async () => await import('./unlink.js'), []],
    upload: [async () => await import('./upload.js'), []],
    'user-search': [async () => await import('./user-search.js'), []],
    users: [async () => await import('./users.js'), []],
    video: [async () => await import('./video.js'), []],
    'video-plus': [async () => await import('./video-plus.js'), []],
    'volume-2': [async () => await import('./volume-2.js'), []],
    'volume-3': [async () => await import('./volume-3.js'), []],
    volume: [async () => await import('./volume.js'), []],
    world: [async () => await import('./world.js'), []],
    x: [async () => await import('./x.js'), []],
    'zoom-out': [async () => await import('./zoom-out.js'), []],
    'zoom-in': [async () => await import('./zoom-in.js'), []],
    'zoom-reset': [async () => await import('./zoom-reset.js'), []],
};

const ICON_NAMES = Object.keys(ICONS);

export { ICON_NAMES as I, ICONS as a };

//# sourceMappingURL=names.js.map